module.exports = __webpack_public_path__ + "static/k2-26e213a571af28493dbadb0ede58d209.png";